// extracted by mini-css-extract-plugin
export default {"content":"style_content__WVild","mobile_slider":"style_mobile_slider__yUc2K"};